var NoScrollDirective = /** @class */ (function () {
    function NoScrollDirective() {
    }
    NoScrollDirective.prototype.onWheel = function (event) {
        event.preventDefault();
    };
    return NoScrollDirective;
}());
export { NoScrollDirective };
